import React from 'react';

import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import WidgetCapacity from 'src/features/statistic/components/WidgetCapacity';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { generalErrorMessages } from 'src/registry/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

const TODAY = 'today';
const YESTERDAY = 'yesterday';

export default function CapacityStatistics() {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    // Both widgets read the same endpoint, so a core that is down fails both of them. The failures are
    // collected here to raise a single toast instead of one per widget.
    const [failedWidgets, setFailedWidgets] = React.useState<Record<string, boolean>>({});
    const hasLoadError = Object.values(failedWidgets).some(Boolean);

    const onTodayErrorChange = React.useCallback(
        (hasError: boolean) => setFailedWidgets((state) => ({ ...state, [TODAY]: hasError })),
        [],
    );
    const onYesterdayErrorChange = React.useCallback(
        (hasError: boolean) => setFailedWidgets((state) => ({ ...state, [YESTERDAY]: hasError })),
        [],
    );

    React.useEffect(() => {
        setTitle(formatMessage(statisticMessages.capacityOverview));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    React.useEffect(() => {
        if (!hasLoadError) return;

        toast({
            variant: 'destructive',
            title: formatMessage(generalErrorMessages.somethingWentWrong),
            description: formatMessage(statisticMessages.dataLoadingServerError),
        });
    }, [hasLoadError, formatMessage]);

    return (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <WidgetCapacity date={dayjs()} onLoadErrorChange={onTodayErrorChange} />
            <WidgetCapacity date={dayjs().subtract(1, 'day')} onLoadErrorChange={onYesterdayErrorChange} />
        </div>
    );
}
